"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortationClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const ReprintShippingLabel_1 = require("./ReprintShippingLabel");
const SortationCenter_1 = require("./SortationCenter");
const DockDoor_1 = require("./DockDoor");
const SortationGaylord_1 = require("./SortationGaylord");
const SortationManifest_1 = require("./SortationManifest");
const SortationPackage_1 = require("./SortationPackage");
const SortationUserJob_1 = require("./SortationUserJob");
const SORTATION_BASIC_AUTH_PASSWORD = process.env.SORTATION_BASIC_AUTH_PASSWORD;
const SORTATION_BASIC_AUTH_USER = process.env.SORTATION_BASIC_AUTH_USER;
const SORTATION_URL = process.env.SORTATION_URL;
const ERROR_CODES = [
    SortationCenter_1.SortationCenterError.SORTATION_CENTER_NOT_FOUND,
    SortationPackage_1.SortationPackageError.DUPLICATE_TRACKING_CODES,
    SortationPackage_1.SortationPackageError.TRACKING_CODE_NOT_FOUND,
    SortationPackage_1.SortationPackageError.SORTATION_PACKAGE_CANCELED,
    SortationPackage_1.SortationPackageError.TRACKING_CODE_EXPIRED,
    SortationPackage_1.SortationPackageError.SORT_CODE_MISSORT,
    SortationGaylord_1.SortationGaylordError.NOT_FOUND,
    SortationGaylord_1.SortationGaylordError.CARRIER_MISSORT,
];
class SortationClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {
        baseURL: SORTATION_URL,
        basicAuthUser: SORTATION_BASIC_AUTH_USER,
        basicAuthPassword: SORTATION_BASIC_AUTH_PASSWORD,
    }) {
        super(config);
        if (!config.baseURL) {
            commons_logs_1.log.warn("SORTATION_URL environment variable is not set");
        }
        if (!config.basicAuthUser || !config.basicAuthPassword) {
            commons_logs_1.log.warn("SORTATION_BASIC_AUTH_USER and/or SORTATION_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async processArrivalScan(barcode, sortationCenterId) {
        return this.put(`/v2/package/${barcode}/sortation-center/${sortationCenterId}/arrival`, undefined).catch(this.handleSortationError.bind(this));
    }
    async createGaylords(numGaylords, sortationCenterId) {
        try {
            return await this.post(`/v2/gaylords/sortation-center/${sortationCenterId}`, { numGaylords });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                SortationCenter_1.SortationCenterError.SORTATION_CENTER_NOT_FOUND,
                SortationGaylord_1.SortationGaylordError.INVALID_NUM_GAYLORDS_TO_CREATE,
            ]);
        }
    }
    async registerGaylordForPackages(barcode) {
        try {
            return await this.put(`/v1/gaylord/${barcode}/registerForPackages`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [SortationGaylord_1.SortationGaylordError.NOT_FOUND]);
        }
    }
    async processAssignPackageToGaylordScan(packageBarcode, gaylordBarcode) {
        return this.put(`/v1/package/${packageBarcode}/assignToGaylord?gaylordId=${gaylordBarcode}`, undefined).catch(this.handleSortationError.bind(this));
    }
    async reprintShippingLabel(trackingCode, sortationCenterId) {
        try {
            return await this.get(`/app/v1/shippingLabel/${trackingCode}/sortationCenter/${sortationCenterId}/reprint`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                ReprintShippingLabel_1.ReprintShippingLabelError.LABEL_NOT_FOUND,
                ReprintShippingLabel_1.ReprintShippingLabelError.MULTIPLE_LABELS_FOR_TRACKING_CODE,
            ]);
        }
    }
    async reprintShippingLabelAsPdf(trackingCode, sortationCenterId) {
        try {
            return await this.get(`/app/v1/shippingLabel/${trackingCode}/sortationCenter/${sortationCenterId}/reprintAsPdf`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                ReprintShippingLabel_1.ReprintShippingLabelError.LABEL_NOT_FOUND,
                ReprintShippingLabel_1.ReprintShippingLabelError.MULTIPLE_LABELS_FOR_TRACKING_CODE,
            ]);
        }
    }
    async processUtilityScan(barcode, scanType, sortationCenterId) {
        try {
            await this.post(`/v1/utility/scan`, {
                barcode,
                scanType,
                sortationCenterId,
            });
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error);
        }
    }
    async assignDivertLaneGaylord(sorterId, divertLaneId, gaylordBarcode) {
        try {
            await this.post(`/v1/sorter/${sorterId}/divert-lane/${divertLaneId}/gaylord`, {
                gaylordBarcode,
            });
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error);
        }
    }
    async getGaylord(barcode) {
        const url = `/v1/gaylord/${barcode}`;
        try {
            return await this.get(url);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [SortationGaylord_1.SortationGaylordError.NOT_FOUND]);
        }
    }
    async getManifestsBySortationCenterId(sortationCenterId) {
        const url = `/v1/sortation-center/${sortationCenterId}/manifests`;
        try {
            return await this.get(url);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [SortationManifest_1.SortationManifestError.BAD_SORTATION_CENTER_ID]);
        }
    }
    async getDockDoors(sortationCenterId) {
        let url = "/api/v1/dock-door";
        if (sortationCenterId) {
            url += `?sortationCenterId=${sortationCenterId}`;
        }
        try {
            return await this.get(url);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getDockDoorLabel(dockDoorId) {
        const url = `/api/v1/dock-door/${dockDoorId}/label`;
        try {
            return await this.get(url);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [DockDoor_1.DockDoorError.DOCK_DOOR_DOES_NOT_EXIST]);
        }
    }
    async processLeftInBuildingScan(gaylordBarcode, leftInBuildingReasonCode, leftInBuildingReasonDetails) {
        try {
            return await this.put(`/v1/gaylord/${gaylordBarcode}/left-in-building`, { leftInBuildingReasonCode, leftInBuildingReasonDetails });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [SortationGaylord_1.SortationGaylordError.NOT_FOUND, SortationGaylord_1.SortationGaylordError.INVALID_LIB_REASON]);
        }
    }
    async processAssignGaylordToDockDoorScan(gaylordBarcode, dockDoorLabelBarcode) {
        try {
            return await this.put(`/v1/gaylord/${gaylordBarcode}/dock-door/${dockDoorLabelBarcode}`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                DockDoor_1.DockDoorError.DOCK_DOOR_DOES_NOT_EXIST,
                SortationGaylord_1.SortationGaylordError.GAYLORD_DOCK_DOOR_MISMATCH,
                SortationGaylord_1.SortationGaylordError.MISSING_GAYLORD_SORT_CODE,
                SortationGaylord_1.SortationGaylordError.NOT_FOUND,
                SortationGaylord_1.SortationGaylordError.DOCK_DOOR_MAPPING_NOT_FOUND,
            ]);
        }
    }
    async getDockDoorForGaylord(gaylordBarcode) {
        try {
            return await this.get(`/v1/gaylord/${gaylordBarcode}/dock-door`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                DockDoor_1.DockDoorError.DOCK_DOOR_DOES_NOT_EXIST,
                SortationGaylord_1.SortationGaylordError.MISSING_GAYLORD_SORT_CODE,
                SortationGaylord_1.SortationGaylordError.NOT_FOUND,
                SortationGaylord_1.SortationGaylordError.DOCK_DOOR_MAPPING_NOT_FOUND,
            ]);
        }
    }
    async startJob(jobType, sortationCenterId) {
        try {
            await this.post(`/v1/sortation-user-job-log/start-job`, {
                jobType,
                sortationCenterId,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                SortationUserJob_1.SortationUserJobLogError.USER_ALREADY_HAS_ACTIVE_JOB,
                SortationUserJob_1.SortationUserJobLogError.FAILED_TO_START_JOB,
            ]);
        }
    }
    async stopJob() {
        try {
            await this.put(`/v1/sortation-user-job-log/stop-job`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                SortationUserJob_1.SortationUserJobLogError.NO_ACTIVE_JOB_FOUND_FOR_USER,
                SortationUserJob_1.SortationUserJobLogError.USER_HAS_MULTIPLE_ACTIVE_JOBS,
                SortationUserJob_1.SortationUserJobLogError.FAILED_TO_STOP_JOB,
            ]);
        }
    }
    async inputManualJobData(sortationCenterId, manualJobData) {
        try {
            await this.post(`/v1/sortation-user-job-log/input-manual-job-data`, {
                sortationCenterId,
                manualJobData,
            });
        }
        catch (err) {
            console.log(err);
            throw (0, base_client_1.mapError)(err, [SortationUserJob_1.SortationUserJobLogError.FAILED_TO_SAVE_MANUAL_JOBS]);
        }
    }
    maybeGetSortationError(err) {
        var _a;
        const { code, message } = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data;
        if (ERROR_CODES.includes(code)) {
            return new errors_1.DeliverrError({
                code,
                message,
            });
        }
    }
    handleSortationError(error) {
        throw this.maybeGetSortationError(error) || this.maybeGetNetworkError(error) || this.getUnknownError(error);
    }
}
exports.SortationClient = SortationClient;
//# sourceMappingURL=SortationClient.js.map